const AproveitamentoCard = (props) => {
  const estiloDoComponente = {
    padding: "1rem",
    textAlign: "center",
    color: "#FFFFFF",
    borderRadius: "12px",
    width: "218px",
    display: "flex",
    flexDirection: "column",
  };

  const estiloDoTitulo = {
    fontSize: "16px",
    fontFamily: "satoshi",
    color: "#fff",
  };

  const calculoHoras = () => {
    const { dataViewTempoEstimado, dataViewTempoGasto, tempoEstimadoColaborador, tempoGastoColaborador } = props.totalObject;

    if (dataViewTempoEstimado && dataViewTempoGasto) {
      const somaTempoEstimado = dataViewTempoEstimado?.reduce(
        (acumulador, valor) => acumulador + valor,
        0
      );
      const somaTempoGasto = dataViewTempoGasto?.reduce(
        (acumulador, valor) => acumulador + valor,
        0
      );

      return somaTempoEstimado - somaTempoGasto;
    }

    if (tempoEstimadoColaborador && tempoGastoColaborador) {
      const somaTempoEstimado = tempoEstimadoColaborador?.reduce(
        (acumulador, valor) => acumulador + valor,
        0
      );
      const somaTempoGasto = tempoGastoColaborador?.reduce(
        (acumulador, valor) => acumulador + valor,
        0
      );

      return somaTempoEstimado - somaTempoGasto;
    }

  };

  const horas = calculoHoras();
  estiloDoComponente.background = horas >= 0 ? "#008735" : "#F64A00";

  return (
    <div style={estiloDoComponente}>
      <span style={estiloDoTitulo}>Aproveitamento:</span>
      <span style={{ fontFamily: "satoshi", fontSize: "24px" }}>
        {horas ? horas : 0} horas
      </span>
    </div>
  );
};

export default AproveitamentoCard;
